import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";

import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";

import { useStyles } from "../GeneralSetting.css";

class GeneralForm extends Component {
  render() {
    const { classes, data, handleChange } = this.props;
    return (
      <div>
        <div style={{ fontSize: 20, fontWeight: "bold" }}>
          Personal Information
        </div>
        <Divider />
        <br />
        <TextField
          name="schoolName"
          type="text"
          required
          label="School Full Name"
          variant="outlined"
          margin="normal"
          placeholder="Enter full name of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.schoolName}
          onChange={handleChange}
        />
        <TextField
          name="shortName"
          type="text"
          required
          label="School Short Name"
          variant="outlined"
          margin="normal"
          placeholder="Enter the short form of your school name"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.shortName}
          onChange={handleChange}
        />
        <TextField
          name="address"
          type="text"
          required
          fullWidth
          label="School Address"
          variant="outlined"
          margin="normal"
          placeholder="Enter the full address of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.address}
          onChange={handleChange}
        />
        <TextField
          name="mobileNumber"
          type="tel"
          required
          label="School Mobile Number"
          variant="outlined"
          margin="normal"
          placeholder="Enter mobile number of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.mobileNumber}
          onChange={handleChange}
        />

        <TextField
          name="landLineNumber"
          type="tel"
          required
          label="School Landline Number"
          variant="outlined"
          margin="normal"
          placeholder="Enter landline number of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.landLineNumber}
          onChange={handleChange}
        />

        <TextField
          name="email"
          type="email"
          required
          label="School Email Address"
          variant="outlined"
          margin="normal"
          placeholder="Enter email of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.email}
          onChange={handleChange}
        />
        <TextField
          name="altMobileNumber"
          type="tel"
          label="Alt Mobile Number(Optional)"
          variant="outlined"
          margin="normal"
          placeholder="Enter the alternate mobile number of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.altMobileNumber}
          onChange={handleChange}
        />
        <TextField
          name="altLandLineNumber"
          type="tel"
          label="Alt Landline Number(Optional)"
          variant="outlined"
          margin="normal"
          placeholder="Enter the alternate landline number of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.altLandLineNumber}
          onChange={handleChange}
        />
        <TextField
          name="altEmail"
          type="tel"
          label="Alt Email Address(Optional)"
          variant="outlined"
          margin="normal"
          placeholder="Enter the alternate email address of your school"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.altEmail}
          onChange={handleChange}
        />

        <div style={{ fontSize: 20, fontWeight: "bold" }}>Social Links</div>
        <Divider />
        <br />

        <TextField
          name="fbLink"
          type="url"
          label="Facebook"
          variant="outlined"
          margin="normal"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            startAdornment: (
              <InputAdornment position="start">
                <FacebookIcon style={{ color: "#004f71" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.fbLink}
          onChange={handleChange}
        />
        <TextField
          name="instaLink"
          type="url"
          label="Instagram"
          variant="outlined"
          margin="normal"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            startAdornment: (
              <InputAdornment position="start">
                <InstagramIcon style={{ color: "#004f71" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.instaLink}
          onChange={handleChange}
        />
        <TextField
          name="twitterLink"
          type="url"
          label="Twitter"
          variant="outlined"
          margin="normal"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            startAdornment: (
              <InputAdornment position="start">
                <TwitterIcon style={{ color: "#004f71" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.twitterLink}
          onChange={handleChange}
        />
        <TextField
          name="youtubeLink"
          type="url"
          label="Youtube"
          variant="outlined"
          margin="normal"
          className={classes.inputWithMargin}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            startAdornment: (
              <InputAdornment position="start">
                <YouTubeIcon style={{ color: "#004f71" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.youtubeLink}
          onChange={handleChange}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(GeneralForm);
